module.exports = __webpack_public_path__ + "img/step06.90696834.png";